// Guides commons footer colophon (DR-2026-270; DR-2026-248 slot-registry
// pattern, ekonomi = graduated reference). Replaces VLT's default Colophon,
// whose "Powered by Plone" text misstates this fleet's stack — the backend is
// Nick (operator, s527). Uses the SVG lockup directly (native transparency).
// Wording is operator-adjustable (voice-charter DEFINE layer).
import logoSrc from '../assets/ljusa-tider-logo.svg';

const GuidesColophon = () => (
  <div className="guides-colophon">
    {/* The lockup links the platform landing (DR-2026-314) — the commons'
        way back to ljusa-tider.se; operator-requested s571. */}
    <a href="https://ljusa-tider.se" aria-label="Ljusa Tider — platform home">
      <img src={logoSrc} alt="LJUSA TIDER" height="72" />
    </a>
    <p>
      <strong>LJUSA TIDER</strong>
      <span className="colophon-meta">
        Built on Nick and Volto Light Theme — open source, end to end.
      </span>
    </p>
  </div>
);

export default GuidesColophon;
